import { IDocContext } from '../../document_transformer_service';
import { log } from '../../log';
import { LRU_CACHE_BYTE_SIZE_LIMIT } from '../helpers';
import { LruCache } from '../lru_cache';
import { AdvancedContextResolver, ContextResolution } from './advanced_context_resolver';

export class OpenTabsResolver extends AdvancedContextResolver {
  static #instance: OpenTabsResolver | undefined;

  static getInstance(): OpenTabsResolver {
    if (!OpenTabsResolver.#instance) {
      log.debug('OpenTabsResolver: initializing');
      OpenTabsResolver.#instance = new OpenTabsResolver();
    }
    return OpenTabsResolver.#instance;
  }

  static destroyInstance(): void {
    OpenTabsResolver.#instance = undefined;
  }

  async *buildContext({
    documentContext,
    includeCurrentFile = false,
  }: {
    documentContext: IDocContext;
    includeCurrentFile?: boolean;
  }): AsyncGenerator<ContextResolution> {
    const lruCache = LruCache.getInstance(LRU_CACHE_BYTE_SIZE_LIMIT);
    const openFiles = lruCache.mostRecentFiles({
      context: documentContext,
      includeCurrentFile,
    });

    for (const file of openFiles) {
      yield {
        uri: file.uri,
        type: 'file' as const,
        content: `${file.prefix}${file.suffix}`,
        fileRelativePath: file.fileRelativePath,
        strategy: 'open_tabs' as const,
        workspaceFolder: file.workspaceFolder ?? { name: '', uri: '' },
      };
    }
  }
}
